import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    email: null,
    token: null,
    refreshToken: null,
    expireAt: null,
    accountType: null,
  },
  reducers: {
    setCredentials: (state, { payload: { access_token, refresh_token, account_type } }) => {
      state.token = access_token;
      state.refreshToken = refresh_token;
      state.accountType = account_type;
    },
    logOut: (state) => {
      state.token = null;
      state.refreshToken = null;
    },
  },
});

export const { setCredentials, logOut } = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentToken = (state) => state.auth.token;
export const selectAccountType = (state) => state.auth.accountType;
